export enum FeedInType {
  SOLAR = 'SOLAR',

  WIND = 'WIND',
}
